import {useQuery, useQueryClient} from '@tanstack/react-query';
import UserController from 'puddleglum/api/UserController';

const useMe = () => {
	const queryClient = useQueryClient();
	const {data, error, isLoading} = useQuery(
		['me'],
		async () => {
			const response = await UserController.me();
			return response.data;
		},
		{
			refetchOnWindowFocus: false,
			retryOnMount: false,
			retry: false,
		},
	);
	const refetchMe = () => {
		queryClient.invalidateQueries(['me']);
	};

	return {me: data, refetchMe, error, isLoading};
};

export default useMe;
